var render = function render(){var _vm=this,_c=_vm._self._c;return _c('masked-input',{staticClass:"text-right form-control input-currency",class:['is-' + _vm.state],attrs:{"type":"text","placeholder":_vm.placeholder,"mask":_vm.numberMask,"guide":true},on:{"change":_vm.callChange,"keyup":_vm.callKeyUp},model:{value:(_vm.valueMask),callback:function ($$v) {_vm.valueMask=$$v},expression:"valueMask"}})
}
var staticRenderFns = []

export { render, staticRenderFns }